import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  Inject,
  forwardRef
} from "@angular/core";

//Services
import { ProgramOutcomeService } from "app/core/services/program-outcome.service";
import { MappingService } from "app/core/services/mapping.service";
import { CourseOutcomeService } from "app/core/services/course-outcome.service";
import { DimmerService } from "app/core/services/dimmer.service";
import { AlertService } from "app/core/services/alert.service";
import { UtilService } from "app/core/services/util.service";

//Models
import { CourseOutcomeValue } from "app/core/models/course-outcome-value";
import { OutcomeMapValue } from "app/core/models/outcome-map-value";
import { Level } from "app/core/models/level";
import { CourseOutcome } from "app/core/models/course-outcome";
import { ProgramOutcome } from "app/core/models/program-outcome";
import { ProgramOutcomeCategory } from "app/core/models/program-outcome-category";
import { CustomError } from "app/core/models/custom-error";
import { CurriculumReview } from "app/core/models/curriculum-review";
import { Loading } from "app/core/models/loading";

//Libraries
import { finalize } from "rxjs/operators";

// import { OutcomeMap } from "app/models/outcome-map";

@Component({
  selector: "app-user-step-mapping",
  templateUrl: "./user-step-mapping.component.html",
  styleUrls: ["./user-step-mapping.component.scss"]
})
export class UserStepMappingComponent implements OnInit {
  @Input()
  courseId: number;
  @Input()
  review: CurriculumReview;

  @Output()
  disableNavigation: EventEmitter<boolean> = new EventEmitter();

  //data
  levels: Array<Level> = [];
  levelsArray: Array<Level> = []; //level key-value array
  courseOutcomes: Array<CourseOutcome> = [];
  courseOutcomeMaps: Array<CourseOutcomeValue> = [];
  programOutcomeCategories: Array<ProgramOutcomeCategory> = [];
  programOutcomeCategoriesArray: Array<ProgramOutcomeCategory> = [];
  programOutcomes: Array<ProgramOutcome> = [];
  programOutcomesArray: Array<any> = []; //plo key-value array
  selectedCourseOutcome: CourseOutcomeValue;

  ploListArray: Array<any> = []; //format: ploListArray[category.id] = { category: category, plos: [] };
  ploUncategorizedArray: Array<any> = [];

  programOutcomesByCategory: Array<ProgramOutcomeCategory> = [];
  programOutcomesWithoutCategory: Array<ProgramOutcome> = [];

  outcomeMapsArray: Array<any> = []; //format: outcomeMapArray[courseOutcomeId][plod] = levelId

  //errors
  actionErrors: Array<CustomError> = [];
  loadError: CustomError;


  actionErrorTitle: string = "Error";

  //flags
  shouldShowForm: boolean = false;
  outcomeMappingCompleted: boolean = true;
  formProcessing: boolean = false;
  justSaved: boolean = false;
  isValueChanged: boolean = false;

  loading: Loading;

  constructor(
    // private mappingService: MappingService,
    private programOutcomeService: ProgramOutcomeService,
    private mappingService: MappingService,
    private dimmerService: DimmerService,
    private alertService: AlertService,
    private courseOutcomeService: CourseOutcomeService,
    private utilService: UtilService // private dimmerService: DimmerService
  ) {}

  async ngOnInit() {
    this.loading = new Loading(true, "Loading outcome maps...");

    //load current course outcomes & outcome maps
    (async () => {
      try {

        //load PLO categories
        this.programOutcomeCategories = await this.programOutcomeService.getProgramOutcomeCategoriesForCourse(
          this.courseId
        );


        //after categories are loaded, load PLO
        this.programOutcomes = await this.programOutcomeService.getProgramOutcomesForCourse(
          this.courseId
        );

        //group them by categories
        this.utilService.groupPlosByCategory(
          this.programOutcomes,
          this.programOutcomeCategories,

          (programOutcomesByCategory, programOutcomesWithoutCategory) => {
            // console.log(programOutcomesByCategory);
            // console.log(programOutcomesWithoutCategory);

            this.programOutcomesByCategory = programOutcomesByCategory;
            this.programOutcomesWithoutCategory = programOutcomesWithoutCategory;

          }
        );


        let outcomeMapsArray = [];

        //load levels
        this.levels = await this.mappingService.getScaleLevelsForCourse(
          this.courseId
        );

        //create levels[id]=level array
        this.levels.forEach(level => {
          this.levelsArray[level.id] = level;
        });

        //load course outcoems
        let courseOutcomes = await this.courseOutcomeService.getCourseOutcomes(
          this.courseId
        );

        for (let courseOutcome of courseOutcomes) {
          if (courseOutcome.id) {
            this.courseOutcomeMaps.push(
              new CourseOutcomeValue(
                courseOutcome.id,
                courseOutcome.description
              )
            );

            //next load course outcome maps
            let outcomeMapValues: Array<
              OutcomeMapValue
            > = await this.mappingService.getOutcomeMapValues(
              this.courseId,
              courseOutcome.id
            );


            //initialize outcome maps array

            outcomeMapsArray[courseOutcome.id] = [];

            for (let plo of this.programOutcomes) {
              outcomeMapsArray[courseOutcome.id][plo.id] = null;
            }

            //assign outcome map value
            for (let outcomeMapValue of outcomeMapValues) {
              outcomeMapsArray[courseOutcome.id][
                outcomeMapValue.programOutcomeId
              ] = this.levelsArray[outcomeMapValue.levelId]
                ? this.levelsArray[outcomeMapValue.levelId]
                : null;
            }

          }
        }

        this.outcomeMapsArray = outcomeMapsArray;

      } catch (e) {
        console.log(e);
        this.loadError = e;
      } finally {
        this.loading.isLoading = false;
      }
    })();
  }

  async saveOutcomeMaps() {
    this.formProcessing = true;

    //console.log(this.outcomeMapsArray);

    try {
      //save this.outcomeMapsArray
      for (let key of Object.keys(this.outcomeMapsArray)) {
        //console.log(this.outcomeMapsArray[key]);
        await this.mappingService.updateOutcomeMaps(
          this.courseId,
          +key,
          this.outcomeMapsArray[key]
        );
      }

      this.justSaved = true;

      setTimeout(() => {
        this.justSaved = false;
      }, 2000);
    } catch (e) {
      this.actionErrors.push(e);
      window.scrollTo(0, 0);
    } finally {
      this.isValueChanged = false;
      this.formProcessing = false;
      this.emitDisableNavigation(false);
    }
  }

  /******************************************
   * Map Value changed - update outcome map
   ******************************************/
  valueChanged(
    courseOutcomeId: number,
    programOutcomeId: number,
    selectedLevel: Level
  ) {
    this.isValueChanged = true;
    this.outcomeMapsArray[courseOutcomeId][programOutcomeId] = selectedLevel;
    this.emitDisableNavigation(true);
  }

  /**********************************
   * Hide Form
   *********************************/
  cancelForm() {
    this.shouldShowForm = false;
    this.dimmerService.dimWindow(false);
  }

  handleActionErrors() {
    //show alert - warning
    this.alertService.showAlert(
      false,
      "Error while updating the database.",
      false,
      this.actionErrors
    );
  }

  clearAll() {
    this.shouldShowForm = false;
    this.formProcessing = false;
    this.selectedCourseOutcome = null;
    this.dimmerService.dimWindow(false);
  }

  emitDisableNavigation(isDisabled: boolean) {
    this.disableNavigation.emit(isDisabled);
  }
}
